import React from "react";
import { motion } from "framer-motion";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <motion.footer
      className="relative bg-black/90 text-gray-300 py-12 px-6"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">

        {/* Brand Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-center md:text-left"
        >
          <h2 className="text-2xl font-bold text-white mb-1">Rameez Murtaza</h2>
          <p className="text-gray-400">Full-Stack Developer & AI Innovator</p>
        </motion.div>

        {/* Navigation */}
        <motion.nav
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <ul className="flex flex-col md:flex-row gap-4 md:gap-8 text-center">
            <li>
              <a
                href="#about"
                className="hover:text-blue-400 transition-colors font-medium"
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="hover:text-red-400 transition-colors font-medium"
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="hover:text-orange-400 transition-colors font-medium"
              >
                Contact
              </a>
            </li>
          </ul>
        </motion.nav>

        {/* Social Icons */}
        <motion.div
          className="flex gap-6 text-xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <motion.a
            href="https://www.linkedin.com/in/rameez-murtaza/"
            target="_blank"
            rel="noreferrer"
            whileHover={{ scale: 1.2, color: "#0A66C2" }}
            whileTap={{ scale: 0.95 }}
            className="transition-colors"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </motion.a>
          <motion.a
            href="https://github.com/rameezmurtaza"
            target="_blank"
            rel="noreferrer"
            whileHover={{ scale: 1.2, color: "#F1502F" }}
            whileTap={{ scale: 0.95 }}
            className="transition-colors"
            aria-label="GitHub"
          >
            <FaGithub />
          </motion.a>
          <motion.a
            href="mailto:rameezmurtaza@example.com"
            whileHover={{ scale: 1.2, color: "#F59E0B" }}
            whileTap={{ scale: 0.95 }}
            className="transition-colors"
            aria-label="Email"
          >
            <FaEnvelope />
          </motion.a>
        </motion.div>
      </div>

      {/* Footer Bottom */}
      <motion.div
        className="mt-10 text-center text-gray-500 text-sm"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <p>© {new Date().getFullYear()} Rameez Murtaza. All rights reserved.</p>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
